import React from "react";
import { useLocalizedText } from "@/utils/hooks/useLocalizedText";
import { useInfiniteFlightDetailsAirlinesQuery } from "@/services/reports";
import { InfiniteSearchSelect } from "@/Component/InfiniteSearchSelect";
import { useFlightEditRow } from "@/Pages/Makkah/Departure/FlightEditContext";

const PAGE_SIZE = 10;

/**
 * Shared select for flight-details airlines with infinite scroll and search.
 * Uses API: makkah/flight-details/airlines?search=...&pageSize=10&page=...
 * For edit-mode row data, use useFlightEditRow() from @/Pages/Makkah/Departure/FlightEditContext.
 */
export const SelectFlightAirlines = (props) => {
  const { getLocalizedText } = useLocalizedText();
  const editRow = useFlightEditRow();
  const prependedItems = editRow?.airline ? [editRow.airline] : [];

  return (
    <InfiniteSearchSelect
      {...props}
      queryHook={useInfiniteFlightDetailsAirlinesQuery}
      queryParams={{ pageSize: PAGE_SIZE }}
      prependedItems={prependedItems}
      getItemsFromPage={(page) => page?.data?.data ?? page?.data ?? []}
      mapItemToOption={(airline) => ({
        value: String(airline?.id ?? ""),
        label: getLocalizedText(airline?.name_ar, airline?.name_en) || String(airline?.id ?? ""),
      })}
    />
  );
};
